import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Popup } from 'components/Popup'
import { format, parse } from 'libphonenumber-js'
import { STORE_TECH_BASE_URL } from '../../pages/customer-support/constants'
import Loader from '../Loader'
import './style.scss'
import API from '../../lib/api'
import { getMessage } from 'lib/translator'
import { LINKPASS_ADMIN_URL, LINK_HOST } from 'config/app'
import { hasPermissions } from 'lib/auth'

class CustomerDetailsCard extends Component {
  constructor() {
    super()
    this.state = {
      errorMessage: '',
      loading: false,
      success: false,
      vc: '',
      hasGetLinkAccPermissions: hasPermissions(
        'loyalty',
        'link/search-users',
        'post',
        true
      ),
      hasResetPasswordPermissions: hasPermissions(
        'linkpass-admin',
        'reset-password',
        'post'
      ),
      hasUpdatePersonalInfoPermissions: hasPermissions(
        'linkpass-admin',
        'update-profile',
        'patch'
      ),
    }
    this.handleUnblockCustomer = this.handleUnblockCustomer.bind(this)
    this.handleSendResetPasswordLink =
      this.handleSendResetPasswordLink.bind(this)
    this.handleLogoutUser = this.handleLogoutUser.bind(this)
    this.handlePatchUserPhone = this.handlePatchUserPhone.bind(this)
  }
  handleUnblockCustomer(customerID) {
    const api = new API({
      url: `${STORE_TECH_BASE_URL}/store/v0.2/customers/unblock/${customerID}`,
    })
    this.setState({
      loading: true,
      sucess: false,
    })
    api
      .put()
      .then(
        () => {
          // window.location.reload()
          this.setState({
            errorMessage: '',
            success: true,
          })
        },
        (error) => {
          if (error.code === 401) {
            throw error
          }
          this.setState({
            errorMessage: 'Unable to verify',
            success: false,
          })
        }
      )
      .finally(() => {
        this.setState({
          loading: false,
        })
      })
  }

  handleSendResetPasswordLink() {
    this.setState({ resetPasswordloading: true })
    const resetPasswordApi = new API({
      url: `${LINKPASS_ADMIN_URL}/linkpass-admin-service/user/auth0/tickets/password-change`,
    })
    resetPasswordApi
      .post({ email: this.props.email })
      .then((res) => {
        if (res.ticket) {
          this.setState({
            changePasswordTicket: res.ticket,
            showPopup: true,
            resetPasswordloading: false,
          })
        }
      })
      .catch((err) => {
        this.setState({
          errorMessage: err.message,
          showPopup: true,
          resetPasswordloading: false,
        })
      })
  }

  handleLogoutUser() {
    const logoutUrl = new API({
      url: `${LINKPASS_ADMIN_URL}/linkpass-admin-service/user/logout`,
    })
    logoutUrl
      .post({ email: this.props.email })
      .then(() => {
        this.setState({ forceLogoutSuccess: true })
      })
      .catch((err) => {
        this.setState({ errorMessage: err.message })
      })
      .finally(() => {
        this.setState({
          showPopup: true,
        })
      })
  }

  handlePatchUserPhone() {
    this.setState({ resetPhoneLoading: true })
    const patchApi = new API({
      url: `${LINKPASS_ADMIN_URL}/linkpass-admin-service/user/uid/${this.props.uid}/phone-number`,
    })
    patchApi
      .patch()
      .then(() => {
        this.setState({ resetPhoneSuccess: true, resetPhoneLoading: false })
      })
      .catch((err) => {
        this.setState({ errorMessage: err.message })
      })
      .finally(() => {
        this.setState({
          showPopup: true,
          resetPhoneLoading: false,
        })
      })
  }

  componentDidMount() {
    const linkAccByUidApi = new API({
      url: `${LINK_HOST}/users/search`,
    })
    this.state.hasGetLinkAccPermissions &&
      linkAccByUidApi
        .post({ uid: [this.props.uid] })
        .then((res) => {
          this.setState({ vc: res[0]?.vc })
        })
        .catch(() => {
          // show default backoffice error
        })
  }

  render() {
    const {
      name,
      phone,
      email,
      uid,
      id,
      editHandler,
      showPhoneResetButton,
      hideActions,
    } = this.props
    return (
      <div className="CustomerDetailsCard">
        <div className="customer-details">
          <div className="detail">
            <div>{name}</div>
            {this.props.isEntity ? (
              <>
                <div style={{ textAlign: 'left' }}>
                  UEN: <small>{this.props.uen}</small>
                </div>
                <div className="button-container">
                  <button
                    data-testid="button-edit"
                    className="button edit-btn"
                    onClick={() => editHandler()}
                  >
                    Edit
                  </button>
                  {this.props.isSaved && (
                    <div className="changes-saved">
                      {getMessage('eVoucher.entities.saved')}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <div>{email}</div>
                <div>
                  {phone && phone.length > 0
                    ? format(parse(phone), 'International')
                    : phone}
                </div>
                <br />
                <div
                  style={{
                    color: 'rgb(128, 149, 157)',
                    fontWeight: 400,
                    fontSize: 11,
                  }}
                >
                  UID: {uid}
                </div>
                {this.state.hasGetLinkAccPermissions ? (
                  <div
                    style={{
                      fontWeight: 400,
                      fontSize: 11,
                    }}
                  >
                    {' '}
                    VC (Link):&nbsp;
                    {this.state.vc ? (
                      <a href={`/customer-support/link/vc/${this.state.vc}`}>
                        {this.state.vc}
                      </a>
                    ) : (
                      'none'
                    )}
                  </div>
                ) : null}
                {hideActions ? null : this.state.success ? (
                  <span className="success">Unblocked successfully!</span>
                ) : (
                  <div className="button-container">
                    {this.state.loading ? (
                      <Loader size="sm" />
                    ) : (
                      <button
                        className="button"
                        onClick={() => this.handleUnblockCustomer(id)}
                      >
                        Unblock Scan & Go
                      </button>
                    )}
                    {this.state.errorMessage && (
                      <span className="error">{this.state.errorMessage}</span>
                    )}
                  </div>
                )}
                {!hideActions && this.state.hasResetPasswordPermissions && (
                  <button
                    className="password-reset-button"
                    onClick={this.handleSendResetPasswordLink}
                  >
                    <b>
                      {this.state.resetPasswordloading
                        ? '...'
                        : 'Password reset link'}
                    </b>
                  </button>
                )}
              </>
            )}
            {!hideActions && (
              <button
                className="force-logout-button"
                onClick={this.handleLogoutUser}
              >
                <b>
                  {this.state.forceLogoutLoading ? '...' : 'Force logout user'}
                </b>
              </button>
            )}
            {!hideActions && showPhoneResetButton && (
              <button
                className="reset-phone-button"
                onClick={this.handlePatchUserPhone}
              >
                <b>
                  {this.state.resetPhoneLoading
                    ? '...'
                    : 'Reset mobile verification date'}
                </b>
              </button>
            )}
          </div>
        </div>
        <Popup
          show={this.state.showPopup}
          heading={this.state.errorMessage.length > 0 ? 'Error' : 'Success'}
          close={() =>
            this.setState({
              showPopup: false,
              errorMessage: '',
              changePasswordTicket: '',
              newEmail: '',
              newName: '',
              forceLogoutSuccess: false,
            })
          }
        >
          {this.state.errorMessage?.length > 0 && (
            <div style={{ color: 'red' }}>{this.state.errorMessage}</div>
          )}
          {this.state.changePasswordTicket?.length > 0 && (
            <div>{this.state.changePasswordTicket}</div>
          )}
          {this.state.forceLogoutSuccess && (
            <div>Force user logout success</div>
          )}
          {this.state.resetPhoneSuccess && (
            <div>Reset phone verified date success</div>
          )}
        </Popup>
      </div>
    )
  }
}

export default withRouter(({ location, history, match, ...props }) => (
  <CustomerDetailsCard router={{ location, history, match }} {...props} />
))
